var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"info"},on:{"click":_vm.clickpost}},[_vm._v("提交")]),_c('div',{staticClass:"bm-view",attrs:{"id":"allmap"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }